import { GetServerSideProps } from "next";
import { ReactElement } from "react";

import { getPageProps } from "@services/initial-calls";
import PrivacyPolicy from "@components/shared/legal/privacyPolicy";
import MoveYouOutWrapper from "@components/layouts/moveyououtWrapper";

export default function MoveYouOutHome(): ReactElement {
    return (
        <MoveYouOutWrapper>
            <PrivacyPolicy category="Moving" domain="MoveYouOut.com" />
        </MoveYouOutWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Privacy Policy" });
};
